import { ReactNode } from 'react';
import { classNames } from '@progress/kendo-react-common';
import styles from './Card.module.scss';

export type CardProps = {
    children?: ReactNode,
    className?: string
};

export const Card = ({ children, className }: CardProps) => (
    <div className={classNames(styles.card, className)}>{children}</div>
);

export const CardBody = ({ children, className }: CardProps) => (
    <div className={classNames(styles.body, className)}>{children}</div>
);

export const CardButtons = ({ children, className }: CardProps) => (
    <div className={classNames(styles.buttons, className)}>{children}</div>
);

export const CardHeader = ({ children, className }: CardProps) => (
    <div className={classNames(styles.header, className)}>{children}</div>
);

export const CardSubtitle = ({ children, className }: CardProps) => (
    <div className={classNames(styles.subtitle, className)}>{children}</div>
);

export const CardTitle = ({ children, className }: CardProps) => (
    <div className={classNames(styles.title, className)}>{children}</div>
);

export const CardLabel = ({ children, className }: CardProps) => (
    <div className={classNames(styles.title, className)}>{children}</div>
);
